import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '@lib/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class v4Guard implements CanActivate, CanActivateChild {
	constructor(private apiService: ApiService) {}

    canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean { 
		
        const token = this.apiService.token;

        if(token) {

            const redirect = new URL(`${state.url}?token=${token}`, environment.v4);

            location.replace(redirect);
        }
		
        return false;
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean { return this.canActivate(route, state); }
}